import React from "react";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const getPageNumbers = () => {
    const pages = [];
    const maxPagesToShow = 5;

    if (totalPages <= maxPagesToShow) {
      // Show all pages if total pages are less than maxPagesToShow
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Show ellipsis logic
      if (currentPage <= 3) {
        pages.push(1, 2, 3, 4, "...", totalPages);
      } else if (currentPage > 3 && currentPage < totalPages - 2) {
        pages.push(
          1,
          "...",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "...",
          totalPages
        );
      } else {
        pages.push(
          1,
          "...",
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages
        );
      }
    }

    return pages;
  };

  const handlePageClick = (page) => {
    if (page !== currentPage && page !== "...") {
      onPageChange(page);
    }
  };

  return (
    <div className="flex items-center justify-center space-x-2 mt-6">
      {/* Previous Button */}
      <button
        className={`px-3 py-2 rounded-md border ${
          currentPage === 1
            ? "cursor-not-allowed text-gray-300 border-gray-300"
            : "hover:bg-gray-100 border-gray-400"
        }`}
        disabled={currentPage === 1}
        onClick={() => handlePageClick(currentPage - 1)}
      >
        Previous
      </button>

      {/* Page Numbers */}
      {getPageNumbers().map((number, index) => (
        <button
          key={index}
          className={`px-3 py-2 rounded-md border ${
            number === currentPage
              ? "bg-primary text-white border-black"
              : "hover:bg-gray-100 border-gray-400"
          } ${number === "..." ? "cursor-default" : ""}`}
          onClick={() => handlePageClick(number)}
        >
          {number}
        </button>
      ))}

      {/* Next Button */}
      <button
        className={`px-3 py-2 rounded-md border ${
          currentPage === totalPages
            ? "cursor-not-allowed text-gray-300 border-gray-300"
            : "hover:bg-gray-100 border-gray-400"
        }`}
        disabled={currentPage === totalPages}
        onClick={() => handlePageClick(currentPage + 1)}
      >
        Next
      </button>
    </div>
  );
};

export default Pagination;
